// The lost-approve screen's retry offer, shared by the Swingies and MiniMove result pages: a Hebrew message and
// the "נסה שוב" button that re-sends the approve (see approveRetry.js). Fixed above the status overlays. `message`
// defaults to MSG_APPROVE_RETRY (the offline variant says the connection is down right now).
import React from "react";
import "./ApproveRetryNotice.css";
import { LABEL_APPROVE_RETRY, MSG_APPROVE_RETRY } from "./approveRetry";

const ApproveRetryNotice = ({ onRetry, message = MSG_APPROVE_RETRY }) => (
  <div className="approve-retry-notice" data-testid="approve-retry-notice">
    <p className="rtl approve-retry-text">{message}</p>
    <button type="button" className="approve-retry-button" onClick={onRetry}>
      {LABEL_APPROVE_RETRY}
    </button>
  </div>
);

export default ApproveRetryNotice;
